module.exports = __webpack_public_path__ + "img/h1.c2d1b522.jpg";